import React from 'react';
import { deliverables } from '../data/content';
import { TransformCta } from './CtaButton';
export function Deliverables() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-94" data-mp="10bw7p3vh794d">
      <div className="mx-auto max-w-4xl" data-id="element-95" data-mp="1e1zjt20n5mg3">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-96" data-mp="1e3u7up77luoe">
          📲 ¿Qué recibirás inmediatamente después de comprar?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[14px] leading-relaxed text-navy-800/70 sm:text-lg" data-id="element-97" data-mp="1ny2mqa3bhp43">
          No estás comprando otro material para guardar en tu computadora. Estás obteniendo una ruta
          clínica completa que convierte la incertidumbre en decisiones claras desde el primer
          paciente.
        </p>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-98" data-mp="2maw28fkcje8">
          {deliverables.map(item => <li key={item.titulo} className="rounded-3xl border border-navy-800/10 bg-white p-5 shadow-card sm:p-6" data-id="element-99" data-mp="3uqmymvzlss5r">
              <span className="text-2xl" aria-hidden="true" data-id="element-100" data-mp="3k6x4b8zo4usx">
                {item.emoji}
              </span>
              <h3 className="mt-2 font-display text-lg font-bold leading-snug text-navy-900 sm:text-xl" data-id="element-101" data-mp="3p23zttisat6r">
                {item.titulo}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-navy-800/75 sm:text-[15px]" data-id="element-102" data-mp="2pnnxgc5ezlw">
                {item.texto}
              </p>
            </li>)}
        </ul>

        <div className="mt-8 rounded-3xl border border-violet-200 bg-violet-50 p-6 text-center" data-id="element-103" data-mp="bor5gfvo36ya">
          <p className="font-display text-lg font-bold text-navy-900 sm:text-2xl" data-id="element-104" data-mp="gnvdv4arp0nk">
            Porque cuando tienes una ruta clara…
          </p>
          <p className="mt-2 text-[14px] leading-relaxed text-navy-800/75 sm:text-lg" data-id="element-105" data-mp="lmouv6p9j9sh">
            Cada decisión deja de ser una duda y comienza a convertirse en una consulta mucho más
            segura.
          </p>
        </div>

        <TransformCta headline="Empieza a aplicar la Ruta en tu consulta de hoy." data-id="element-106" data-mp="2fe5bfs4c1uw0" />
      </div>
    </section>;
}